import { useTranslation } from "react-i18next"
import { Button, NewInput, NewInputList, PageHeader } from "../../../../Components"
import { colors, fonts, frames } from "../../../../Styles"
import { Pages } from "../../../../Navigation/Routers/root"
import { useState } from "react"
import { Pen } from "../../../../Components/LocationFeeder/Modals/_Modals/newSectionModalInterfaces"
import { debounce } from "lodash"
import { ListStyle_Types } from "../../../../Definitions"

const systemName = "sow unit"

export default function Freeda_esf() {
  const { t } = useTranslation();

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader
          topHeader={systemName}
          subHeader={t(`menuHeaders.${Pages.freeda_esf}`, { defaultValue: "overview" })}
        />
      </frames._page_inner_header>
      <frames._page_inner_content>

      </frames._page_inner_content>
    </frames.Page_inner>
  )
}
